import React from 'react';
import './Clientes-Modal.css';
import PortalMp4 from './assets/Zona_Residencial/Portal El Bosque.mp4';

const ZonaResidencial = () => {
  return (
    <div className="container">
      <h2> ✅ Proyecto: Residencial Portal del Bosque🌞✨ </h2>
      <br></br>
      <video controls>
        <source src={PortalMp4} type="video/mp4" />
        Tu navegador no soporta la reproducción de video.
      </video>
      <p>
      
        <span className="highlight">
          {' '}
          Energía solar que transforma hogares: eficiencia, ahorro y
          sostenibilidad para una vida más tranquila.
        </span>
        <br />
        <br />
        En el conjunto residencial Portal del Bosque instalamos un sistema solar
        fotovoltaico conectado a la red con una capacidad de 4.13 kWp,
        conformado por 7 paneles solares de alta eficiencia y un inversor
        multicanal de 4.2 kW, una tecnología que garantiza estabilidad,
        seguridad y un óptimo rendimiento energético para las necesidades del
        hogar.
        <br />
        <br />
        Gracias a esta solución, el sistema gestiona de manera eficiente las
        cargas eléctricas residenciales{' '}
        <span className="highlight">
          {' '}
          iluminación, electrodomésticos, equipos de uso continuo
        </span>{' '}
        asegurando energía confiable y reduciendo el consumo tomado de la red.
        <br />
        <br />
        Los objetivos de este proyecto fueron:
        <br />
        <br />✔ Reducir los costos asociados al consumo eléctrico de la
        vivienda
        <br />✔ Implementar una solución sostenible que aporte al cuidado del
        medio ambiente
        <br />✔ Garantizar energía constante para las actividades diarias del
        hogar
        <br />
        <br />
        Hoy, Portal del Bosque genera su propia energía limpia, logrando un
        ahorro significativo en su factura eléctrica mensual y aumentando el
        valor del inmueble mediante una tecnología moderna, eficiente y
        sostenible.
        <br />
        <br />
        Esta instalación convierte la vivienda en un ejemplo de responsabilidad
        energética, demostrando que la sostenibilidad también comienza en casa.
        <br />
        <br />
        Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e
        Innovación, ofreciendo:
        <br />
        <br />
        🔧 Soporte técnico y mantenimiento preventivo.
        <br />
        🔧 Monitoreo del sistema para garantizar máxima eficiencia energética.
        <br />
        🔧 Instalación estructural segura, diseñada para prolongar la vida útil
        del sistema y facilitar su mantnenimiento.
        <br />
        🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo.
        <br />
        🔧 Acompañamiento presencial de nuestros ingenieros durante y después de
        la instalación.
        <br />
        <br />
        <span className="highlight">
          {' '}
          Una decisión inteligente que une sostenibilidad, ahorro y bienestar en
          el hogar.
        </span>
      </p>
    </div>
  );
};

export default ZonaResidencial;
